module.exports = __webpack_public_path__ + "img/gameProject.85386e17.svg";